import { ITermsCondition } from '../_types/terms-conditions';

export const TERMS_CONDITIONS_V1: ITermsCondition[] = [
  {
    main_title:
      'SYARAT DAN KETENTUAN PEMBELI HEALTHY ONE MARKETPLACE B2C VERSI 1.0.0',
    description: `Selamat datang di Platform Healthy One.
    Syarat dan Ketentuan ini merupakan perjanjian antara Pembeli ("Anda") dengan Healthy One ("Kami") yang mengatur hak, kewajiban, dan tanggung jawab Anda terhadap penggunaan layanan atau fitur yang diakses oleh Anda melalui Platform. Silahkan membaca Syarat dan Ketentuan ini dengan seksama.
    Dengan mendaftar, mengakses dan/atau menggunakan layanan di Platform, maka Anda dianggap telah membaca, mengerti, memahami, dan menyetujui seluruh isi dari Syarat dan Ketentuan.`,
    chapter: [
      {
        title: 'Bab I: Ketentuan Umum dan Pendaftaran Akun',
        header: [
          {
            header: 'A. Definisi',
            content: [
              {
                content: (
                  <ol className="list-decimal pl-10 text-justify leading-8">
                    <li>
                      "<strong>Biaya Layanan</strong>" adalah biaya atas
                      penggunaan Layanan Platform dalam pelaksanaan Transaksi
                      pembelian Produk yang dilakukan melalui Platform.
                    </li>
                    <li>
                      "<strong>Harga Produk</strong>" adalah harga yang
                      ditetapkan oleh Pembeli untuk setiap Produk yang dijual
                      melalui Platform dan dapat berubah dari waktu ke waktu.
                    </li>
                    <li>
                      "<strong>Harga Layanan</strong>" adalah harga yang
                      ditetapkan untuk Layanan yang disediakan dan dapat berubah
                      dari waktu ke waktu sesuai dengan kebijakan Healthy One.
                      Pengguna akan diberitahukan mengenai perubahan harga
                      tersebut sebelum layanan diberikan.
                    </li>
                    <li>
                      "<strong>Healthy One</strong>" adalah entitas yang
                      mengoperasikan Platform yang dikelola oleh PT Inti Utama
                      Solusindo, suatu perseroan terbatas yang didirikan
                      berdasarkan hukum Negara Republik Indonesia, beralamat di
                      Ruko Jalur Sutera Jl. Raya Serpong KM.3 29A/62, Kelurahan
                      Pakulonan, Kecamatan Serpong Utara, Kota Tangerang
                      Selatan, Provinsi Banten.
                    </li>
                    <li>
                      "<strong>Layanan</strong>" adalah seluruh fitur dan fungsi
                      layanan yang disediakan oleh Healthy One kepada Pengguna,
                      termasuk namun tidak terbatas pada konsultasi tatap muka,
                      konsultasi daring, <em>marketplace</em>, pemeriksaan
                      laboratorium, layanan <em>homecare</em>, pengiriman hasil
                      pemeriksaan, resep, dan layanan terkait lainnya yang dapat
                      ditambah dan/atau diubah.
                    </li>
                    <li>
                      "<strong>Mitra</strong>" adalah pihak yang telah terdaftar
                      sebagai Pengguna dan menyediakan Layanan dan/atau Produk
                      di Platform, termasuk namun tidak terbatas pada dokter,
                      apotek, laboratorium, klinik, rumah sakit, dan/atau
                      layanan fasilitas kesehatan lainnya termasuk Tenaga
                      Kesehatan.
                    </li>
                    <li>
                      "<strong>Pembeli</strong>" adalah Pengguna terdaftar dan
                      menggunakan Platform untuk membeli Produk yang dijual oleh
                      Penjual di Platform.
                    </li>
                    <li>
                      "<strong>Pengguna</strong>" adalah pihak yang menggunakan
                      layanan Platform dan telah membuat nama akun dan sandi,
                      termasuk namun tidak terbatas pada Pembeli, Penjual atau
                      pihak lain yang mengunjungi Platform.
                    </li>
                    <li>
                      "<strong>Penjual</strong>" adalah Pengguna terdaftar yang
                      membuka toko atau fasilitas kesehatan yang terdaftar dan
                      memiliki toko aktif di Platform termasuk melakukan
                      penawaran atas Produk kepada Pengguna Platform termasuk
                      Mitra terdaftar dalam Platform.
                    </li>
                    <li>
                      "<strong>Platform</strong>" adalah Healthy One Marketplace
                      B2C, termasuk situs web, aplikasi seluler, Sistem
                      Informasi Manajemen (SIM), dan semua layanan terkait yang
                      dioperasikan oleh Healthy One.
                    </li>
                    <li>
                      "<strong>Produk</strong>" adalah semua barang termasuk
                      produk farmasi, alat kesehatan, obat-obatan, atau suplemen
                      yang dijual di Platform.
                    </li>
                    <li>
                      "<strong>Rekam Medis Elektronik</strong>" adalah semua
                      data medis milik Pembeli terkait dengan pemeriksaan
                      kesehatan atau layanan konsultasi yang akan dicatat
                      sebagai Rekam Medis Elektronik pada sistem Healthy One dan
                      dapat diakses kapan saja oleh Pengguna melalui Platform.
                    </li>
                    <li>
                      "<strong>Tenaga Kesehatan</strong>" adalah Pengguna
                      terdaftar dalam Healthy One yang berpraktik sebagai tenaga
                      medis dan tenaga kesehatan berlisensi dan menggunakan
                      Platform untuk memberikan Layanan.
                    </li>
                    <li>
                      "<strong>Transaksi</strong>" adalah setiap proses jual
                      beli Produk yang terjadi antara Penjual dan Pembeli
                      melalui Platform.
                    </li>
                  </ol>
                ),
              },
            ],
          },
          {
            header: 'B. Akun',
            content: [
              {
                content: (
                  <ol className="list-decimal pl-10 text-justify leading-8">
                    <li>
                      Anda menyatakan dan menjamin bahwa Anda telah berusia
                      minimal 18 (delapan belas) tahun atau sudah menikah,
                      cakap, dan tidak berada di bawah pengampuan sehingga
                      berhak dan memiliki kapasitas hukum untuk mengikatkan diri
                      pada Syarat dan Ketentuan ini. Kami menganggap penggunaan
                      akun atas nama Anda dilakukan oleh Anda dan dengan ini
                      Anda setuju dan mengakui bahwa Anda terikat dan
                      bertanggung jawab atas setiap akibat yang timbul dari
                      penggunaan layanan dan/atau Transaksi pada Platform
                      menggunakan akun Anda.
                    </li>
                    <li>
                      Kami tidak melakukan pungutan biaya pendaftaran akun
                      kepada Anda.
                    </li>
                    <li>
                      Anda wajib melakukan pembuatan akun untuk dapat melakukan
                      Transaksi melalui Platform.
                    </li>
                    <li>
                      Anda menjamin bahwa identitas yang digunakan dalam
                      pendaftaran akun adalah akurat, valid, dan bukan merupakan
                      identitas milik pihak mana pun, termasuk namun tidak
                      terbatas pada nama lengkap, nomor telepon aktif, alamat{' '}
                      <em>email</em>, serta alamat lengkap yang akan digunakan
                      untuk pengiriman Produk.
                    </li>
                    <li>
                      Anda bertanggung jawab penuh atas keamanan dan kerahasiaan
                      data akun, termasuk nama Pembeli dan kata sandi. Segala
                      aktivitas yang dilakukan menggunakan akun Anda merupakan
                      tanggung jawab Anda sepenuhnya. Platform tidak pernah
                      meminta kepada Anda informasi baik berupa sandi, kode OTP,
                      maupun kode verifikasi lainnya sehingga Anda dihimbau
                      untuk tidak membagikan data termasuk informasi penting
                      terhadap pihak mana pun yang mengatasnamakan Platform.
                    </li>
                    <li>
                      Anda dapat melakukan perubahan nama pada akun dengan
                      ketentuan setiap perubahan nama akun merupakan tanggung
                      jawab Anda sehingga segala hal dan kewajiban yang timbul
                      sehubungan dengan perubahan nama akun baik sebelum maupun
                      sesudah perubahan nama akun tetap melekat pada Anda.
                    </li>
                    <li>
                      Anda wajib melakukan <em>log out</em> akun setelah selesai
                      menggunakan layanan dan/atau melakukan Transaksi pada
                      Platform dan Anda dapat memberitahukan kepada Kami untuk
                      setiap dugaan penggunaan yang tidak sah dengan
                      mengatasnamakan akun Anda.
                    </li>
                    <li>
                      Anda tidak diperkenankan untuk menjual, menyerahkan
                      dan/atau mengalihkan akun atau sandi kepada pihak ketiga,
                      seluruh akibat dan risiko merupakan tanggung jawab dari
                      Anda.
                    </li>
                    <li>
                      Kami memiliki kewenangan untuk melakukan seluruh tindakan
                      yang dianggap patut terhadap seluruh dugaan pelanggaran
                      atau pelanggaran Syarat dan Ketentuan atau hukum yang
                      berlaku tanpa pemberitahuan terlebih dahulu kepada Anda,
                      termasuk namun tidak terbatas pada suspensi akun,
                      penghapusan akun dan/atau pelaporan kepada pihak yang
                      berwenang termasuk namun tidak terbatas pada Kepolisian.
                    </li>
                    <li>
                      Kami dibebaskan dari segala bentuk kerugian yang timbul
                      akibat penyalahgunaan akun yang terjadi karena kelalaian
                      Anda. Kelalaian tersebut termasuk namun tidak terbatas
                      pada memberikan akses akun melalui notifikasi yang dikirim
                      oleh Kami kepada pihak lain, meminjamkan akun kepada pihak
                      lain, membuka tautan mencurigakan, memperlihatkan atau
                      memberikan kode OTP, sandi, maupun <em>email</em> kepada
                      pihak lain atau tindakan kelalaian Anda lainnya terhadap
                      akun yang berakibat pada kerugian terhadap akun Anda.
                    </li>
                  </ol>
                ),
              },
            ],
          },
          {
            header: 'C. Penggunaan Umum',
            content: [
              {
                content: (
                  <div className="text-justify">
                    <p className="pl-5 text-justify leading-8">
                      Dengan ini Anda setuju:
                    </p>
                    <ol className="list-decimal pl-10 text-justify leading-8">
                      <li>
                        Mengakses dan/atau menggunakan layanan Platform untuk
                        tujuan yang tidak melanggar hukum di Negara Republik
                        Indonesia.
                      </li>
                      <li>
                        Anda dianggap mengetahui seluruh peraturan
                        perundang-undangan yang berlaku di Negara Republik
                        Indonesia dalam setiap Transaksi pada Platform.
                      </li>
                      <li>
                        Anda tidak akan berpura-pura atau mengaku menjadi orang
                        lain/entitas dengan tujuan melakukan perbuatan yang
                        melanggar hukum.
                      </li>
                      <li>
                        Kami tidak memantau setiap deskripsi, informasi atau
                        data Produk yang ditampilkan oleh Penjual. Anda
                        menyetujui bahwa seluruh deskripsi, informasi atau data
                        yang terdapat dalam Platform adalah akurat.
                      </li>
                      <li>
                        Anda menjamin untuk tidak melakukan tindakan apa pun dan
                        dalam bentuk apa pun yang dapat mengganggu layanan
                        Platform dan menimbulkan efek merugikan bagi
                        keberlangsungan operasional usaha Kami.
                      </li>
                      <li>
                        Bertanggung jawab atas seluruh kegiatan yang dilakukan
                        di Platform atas nama Anda dan/atau menggunakan akun
                        Anda.
                      </li>
                      <li>
                        Memberikan ulasan dan penilaian yang jujur dan relevan
                        terhadap Produk dan Penjual melalui fitur yang tersedia
                        di Platform setelah Produk diterima oleh Anda.
                      </li>
                      <li>
                        Anda tidak akan menyimpan, meniru, mengubah, atau
                        menyebarkan konten dan fitur pada Platform, termasuk
                        namun tidak terbatas pada pelayanan, konten, hak cipta,
                        hak kekayaan intelektual yang terdapat pada Platform.
                      </li>
                      <li>
                        Anda tidak akan mengambil atau mengumpulkan informasi
                        dari Pengguna lain tanpa sepengetahuan Pengguna lain.
                      </li>
                    </ol>
                  </div>
                ),
              },
            ],
          },
        ],
      },
      {
        title: 'Bab II: Layanan dan Transaksi',
        header: [
          {
            header: 'D. Layanan Healthy One',
            content: [
              {
                content: (
                  <div className="text-justify">
                    <ol className="list-decimal pl-10 text-justify leading-8">
                      <li>
                        Fitur <em>Homecare</em>
                      </li>
                      <ol className="list-[lower-alpha] pl-10 text-justify leading-8">
                        <li>
                          <em>Homecare</em> adalah pemeriksaan kesehatan di
                          rumah oleh Mitra (dokter) dan/atau Tenaga Kesehatan
                          profesional. Pemeriksaan kesehatan ini meliputi
                          pemeriksaan tanda vital, konsultasi dengan Mitra
                          (dokter) di rumah, serta pengambilan sampel
                          pemeriksaan laboratorium bila diperlukan;
                        </li>
                        <li>
                          Proses kunjungan untuk <em>homecare</em> akan
                          dilakukan sesuai dengan jadwal yang disepakati oleh
                          Anda dengan Mitra dan/atau Tenaga Kesehatan yang
                          tersedia melalui Platform berdasarkan lokasi Anda;
                        </li>
                        <li>
                          Pengguna akan melakukan pembayaran sesuai dengan Harga
                          Layanan yang tercantum dalam deskripsi Layanan pada
                          Platform termasuk dengan Biaya Layanan. Pembayaran
                          dapat dilakukan dengan beberapa pilihan metode
                          pembayaran sesuai dengan ketentuan pada deskripsi
                          masing-masing Layanan yang ditentukan oleh Mitra dan
                          dicantumkan pada Platform, sebagai berikut:
                        </li>
                        <p className="pl-5 text-justify leading-8">
                          1) Pembayaran dengan uang muka (DP) pada saat
                          penjadwalan dan pelunasan dilakukan setelah Layanan
                          selesai dilaksanakan; atau
                        </p>
                        <p className="pl-5 text-justify leading-8">
                          2) Pembayaran penuh (lunas) pada saat penjadwalan
                          melalui Platform; atau
                        </p>
                        <p className="pl-5 text-justify leading-8">
                          3) Pembayaran dilakukan secara langsung saat Layanan
                          dilaksanakan.
                        </p>
                        <li>
                          Anda tidak dapat membatalkan jadwal <em>homecare</em>{' '}
                          yang telah disepakati. Apabila Anda melakukan
                          pembatalan, maka seluruh biaya yang telah dibayarkan
                          oleh Anda tidak dapat dilakukan pengembalian dana (
                          <em>refund</em>);
                        </li>
                        <li>
                          Anda hanya dapat melakukan penjadwalan ulang maksimal
                          1x (satu kali) untuk jadwal <em>homecare</em> yang
                          telah disepakati paling lambat 3 (tiga) hari sebelum
                          jadwal yang telah disepakati dengan jadwal yang dapat
                          ditentukan kembali oleh Anda sesuai informasi jadwal
                          yang tercantum pada Platform;
                        </li>
                        <li>
                          Anda tidak dapat melakukan pembatalan jadwal{' '}
                          <em>homecare</em> yang telah disepakati apabila Mitra
                          atau Tenaga Kesehatan telah menuju alamat Anda;
                        </li>
                        <li>
                          Hasil pemeriksaan dalam bentuk digital akan langsung
                          dikirimkan ke Platform untuk dipantau oleh Mitra dan
                          dapat diakses melalui akun Anda;
                        </li>
                        <li>
                          Seluruh hasil pemeriksaan laboratorium merupakan
                          tanggung jawab dari Mitra dan Tenaga Kesehatan
                          terkait.
                        </li>
                      </ol>
                      <li>
                        Fitur Konsultasi <em>Online</em>
                      </li>
                      <p className="text-justify leading-8">
                        Anda dapat melakukan konsultasi jarak jauh melalui{' '}
                        <em>chat</em> atau panggilan dengan Mitra (dokter) yang
                        disesuaikan dengan kebutuhan Anda yang dapat diakses
                        melalui Platform dengan ketentuan sebagai berikut:
                      </p>
                      <ol className="list-[lower-alpha] pl-10 text-justify leading-8">
                        <li>
                          Anda dapat mengakses informasi jadwal berdasarkan
                          lokasi Anda pada masing-masing Mitra (dokter);
                        </li>
                        <li>
                          Anda akan melakukan pembayaran sesuai dengan Harga
                          Layanan yang tercantum dalam deskripsi Layanan pada
                          Platform termasuk dengan Biaya Layanan. Pembayaran
                          dapat dilakukan secara bertahap yaitu pembayaran uang
                          muka (DP) dilakukan pada saat penjadwalan dan
                          pelunasan setelah Layanan selesai dilaksanakan, sesuai
                          dengan ketentuan pada deskripsi masing-masing Layanan
                          yang dicantumkan pada Platform;
                        </li>
                        <li>
                          Anda dapat melakukan penjadwalan sesuai dengan fitur
                          yang tersedia pada Platform yaitu:
                        </li>

                        <p className="pl-5 text-justify leading-8">
                          1) layanan reguler, Anda dapat memilih Mitra (dokter)
                          yang akan berkonsultasi dengan Anda dan jadwal yang
                          tersedia pada Platform, kemudian Anda dapat melakukan
                          pembayaran sesuai dengan Harga Layanan termasuk Biaya
                          Layanan yang tercantum dalam Platform; atau
                        </p>
                        <p className="pl-5 text-justify leading-8">
                          2) layanan <em>express</em>, Anda melakukan pembayaran
                          Harga Layanan termasuk Biaya Layanan sesuai yang
                          tercantum dalam Platform terlebih dahulu, mengisi
                          keluhan medis, kemudian Anda akan masuk ke dalam
                          antrean secara otomatis melalui sistem Platform untuk
                          ditangani oleh Mitra (dokter) yang tersedia tanpa
                          pemilihan Mitra (dokter) yang akan berkonsultasi
                          dengan Anda secara spesifik.
                        </p>

                        <li>
                          Anda dapat melakukan penjadwalan ulang maksimal 1x
                          (satu kali) untuk jadwal konsultasi <em>online</em>{' '}
                          yang telah disepakati paling lambat 3 (tiga) hari
                          sebelum sesi konsultasi <em>online</em> dimulai dengan
                          jadwal yang dapat ditentukan kembali oleh Anda sesuai
                          informasi jadwal yang tercantum pada Platform;
                        </li>
                        <li>
                          Jika Anda melakukan penjadwalan ulang lebih dari 1x
                          (satu kali) untuk jadwal konsultasi <em>online</em>{' '}
                          maka sesi konsultasi <em>online</em> dianggap batal
                          dan pembayaran yang telah dilakukan oleh Anda tidak
                          dapat dilakukan pengembalian dana (<em>refund</em>);
                        </li>
                        <li>
                          Apabila penjadwalan ulang atau pembatalan disebabkan
                          oleh Mitra (dokter) yang tidak dapat hadir pada jadwal
                          sesi konsultasi <em>online</em> yang telah disepakati,
                          maka Anda dapat melakukan penjadwalan ulang kembali
                          tanpa dikenakan biaya tambahan;
                        </li>
                        <li>
                          Anda dapat menghubungi Mitra (dokter) pada jadwal yang
                          telah ditentukan pada saat Mitra (dokter) berstatus{' '}
                          <em>online</em>;
                        </li>
                        <li>
                          Durasi konsultasi sesuai dengan informasi yang tertera
                          sesuai dengan jadwal sesi konsultasi yang dipilih oleh
                          Anda;
                        </li>
                        <li>
                          Anda wajib memberikan informasi kesehatan Anda
                          meliputi gejala dan keluhan secara lengkap, jelas, dan
                          akurat kepada Mitra (dokter) selama sesi konsultasi;
                        </li>
                        <li>
                          Anda setuju bahwa konsultasi yang dilakukan melalui
                          Platform tidak menggantikan pemeriksaan dengan Mitra
                          (dokter) secara langsung atau tatap muka;
                        </li>
                        <li>
                          Setelah konsultasi selesai dilakukan, Mitra (dokter)
                          akan memberikan Anda hasil konsultasi berupa Ringkasan
                          Medis dan resep dengan Produk terkait yang dapat Anda
                          beli melalui fitur <em>marketplace</em> yang akan
                          dikirimkan ke alamat Pengguna;
                        </li>
                        <li>
                          Anda setuju bahwa ketepatan Mitra (dokter) dalam
                          memberikan resep ditentukan berdasarkan pada setiap
                          informasi yang Anda berikan selama sesi konsultasi;
                        </li>
                        <li>
                          Seluruh Ringkasan Medis, diagnosa, resep yang
                          disediakan oleh Mitra (dokter) merupakan kewenangan
                          tersendiri dari Mitra (dokter) yang bersangkutan.
                        </li>
                      </ol>
                      <li>Fitur Konsultasi Tatap Muka</li>
                      <p className="text-justify leading-8">
                        Anda dapat melakukan pemesanan jadwal konsultasi tatap
                        muka dengan Mitra (dokter) dan fasilitas kesehatan yang
                        Anda pilih sesuai dengan lokasi dan kebutuhan Anda
                        melalui Platform dengan ketentuan sebagai berikut:
                      </p>
                      <ol className="list-[lower-alpha] pl-10 text-justify leading-8">
                        <li>
                          Anda dapat mengakses informasi untuk konsultasi tatap
                          muka meliputi jadwal konsultasi tatap muka, fasilitas
                          kesehatan sesuai dengan lokasi yang Anda pilih, dan
                          Mitra (dokter) yang berpraktik pada masing-masing
                          fasilitas kesehatan;
                        </li>
                        <li>
                          Anda dapat melakukan pemesanan konsultasi tatap muka
                          sesuai dengan kebutuhan Anda dengan memilih jadwal
                          sesi konsultasi tatap muka yang tersedia pada
                          fasilitas kesehatan yang Anda pilih dan Mitra (dokter)
                          yang dipilih untuk berkonsultasi dengan Anda sesuai
                          dengan informasi jadwal yang tersedia;
                        </li>
                        <li>
                          Untuk memproses dan <em>booking</em> jadwal konsultasi
                          tatap muka yang telah Anda pilih, Anda akan melakukan
                          pembayaran sesuai dengan Harga Layanan yang tercantum
                          dalam deskripsi Layanan pada Platform termasuk dengan
                          Biaya Layanan. Pembayaran dapat dilakukan dengan
                          beberapa pilihan metode pembayaran sesuai dengan
                          ketentuan pada deskripsi masing-masing Layanan yang
                          ditentukan oleh Mitra dan dicantumkan pada Platform,
                          sebagai berikut:
                        </li>
                        <p className="pl-5 text-justify leading-8">
                          1) Pembayaran dengan uang muka (DP) pada saat
                          penjadwalan dan pelunasan dilakukan setelah Layanan
                          selesai dilaksanakan; atau
                        </p>
                        <p className="pl-5 text-justify leading-8">
                          2) Pembayaran penuh (lunas) pada saat penjadwalan
                          melalui Platform; atau
                        </p>
                        <p className="pl-5 text-justify leading-8">
                          3) Pembayaran dilakukan secara langsung pada fasilitas
                          kesehatan.
                        </p>
                        <li>
                          Anda tidak dapat membatalkan jadwal konsultasi tatap
                          muka yang telah disepakati. Apabila Anda melakukan
                          pembatalan, maka seluruh biaya yang telah dibayarkan
                          oleh Anda tidak dapat dilakukan pengembalian dana (
                          <em>refund</em>);
                        </li>
                        <li>
                          Anda hanya dapat melakukan penjadwalan ulang maksimal
                          1x (satu kali) untuk jadwal konsultasi tatap muka yang
                          telah disepakati paling lambat 3 (tiga) hari sebelum
                          jadwal yang telah disepakati dengan jadwal yang dapat
                          ditentukan kembali oleh Anda sesuai informasi jadwal
                          yang tercantum pada Platform;
                        </li>
                        <li>
                          Anda dapat datang pada fasilitas kesehatan yang Anda
                          pilih pada jadwal sesi konsultasi tatap muka yang
                          telah terkonfirmasi untuk melakukan konsultasi tatap
                          muka dengan Mitra (dokter) dengan menunjukkan bukti
                          pemesanan konsultasi tatap muka dari Platform.
                        </li>
                      </ol>
                      <li>Fitur Rekam Medis Elektronik</li>
                      <ol className="list-[lower-alpha] pl-10 text-justify leading-8">
                        <li>
                          Kami hanya bertindak sebagai penyedia sistem
                          elektronik bukan sebagai pemilik atau pengendali isi
                          Rekam Medis Elektronik;
                        </li>
                        <li>
                          Standar keamanan Rekam Medis Elektronik yang terdapat
                          dalam Platform tunduk pada Kebijakan Privasi;
                        </li>
                        <li>
                          Rekam Medis Elektronik menjadi kepemilikan Penjual
                          yang membuat dan/atau mengelola Rekam Medis
                          Elektronik;
                        </li>
                        <li>
                          Anda dapat mengakses secara pribadi Rekam Medis
                          Elektronik melalui akun Anda sesuai dengan fitur yang
                          tersedia dalam Platform;
                        </li>
                        <li>
                          Kami tidak bertanggung jawab atas ketepatan,
                          kelengkapan, dan keabsahan dari Rekam Medis Elektronik
                          yang diinput oleh Penjual ke dalam sistem Healthy One;
                        </li>
                        <li>
                          Kami berhak membatasi dan/atau menonaktifkan akses
                          Anda untuk fitur Rekam Medis Elektronik apabila
                          ditemukan dugaan pelanggaran terhadap Syarat dan
                          Ketentuan ini atau ketentuan hukum yang berlaku.
                        </li>
                      </ol>
                      <li>
                        Fitur <em>Marketplace</em>
                      </li>
                      <p className="text-justify leading-8">
                        Layanan ini menyediakan akses bagi Pembeli untuk dapat
                        melihat dan membeli berbagai Produk yang ditawarkan
                        melalui Platform. Kami berperan sebagai penyedia sarana
                        untuk menghubungan Pembeli dengan Penjual untuk dapat
                        melakukan Transaksi. Platform dapat menampilkan
                        informasi Produk, ketersediaan stok, serta konten yang
                        ditampilkan oleh Penjual, namun Kami tidak menjamin
                        keakuratan atau kelengkapan informasi tersebut. Kami
                        berupaya untuk memastikan bahwa informasi yang
                        ditampilkan telah diverifikasi sesuai dengan kebijakan
                        internal Kami.
                      </p>
                    </ol>
                    <p className="pl-10 text-justify leading-8">
                      Kami berhak sewaktu-waktu mengubah, menghapus, mengurangi,
                      menambah dan/atau memperbarui fitur atau Layanan dalam
                      Platform. Pemakaian Pengguna yang berkelanjutan dianggap
                      sebagai persetujuan kepada perubahan, penghapusan,
                      pengurangan, penambahan dan/atau pembaruan fitur dan/atau
                      Layanan dalam Platform.
                    </p>
                  </div>
                ),
              },
            ],
          },
          {
            header: 'E. Proses Transaksi Pembelian Produk',
            content: [
              {
                content: (
                  <ol className="list-decimal pl-10 text-justify leading-8">
                    <li>
                      Anda wajib melakukan Transaksi melalui prosedur yang telah
                      ditetapkan oleh Platform. Transaksi yang dilakukan oleh
                      Anda melalui Platform menggunakan metode pembayaran yang
                      tersedia dan dipilih oleh Anda pada Platform.
                    </li>
                    <li>
                      Anda wajib membayar penuh atas setiap Transaksi yang
                      dilakukan di Platform dengan jangka waktu yang ditentukan
                      secara spesifik untuk masing-masing metode pembayaran Anda
                      pilih pada Platform.
                    </li>
                    <li>
                      Anda bertanggung jawab untuk membaca, memahami, dan
                      menyetujui informasi Produk, termasuk namun tidak terbatas
                      pada deskripsi, harga, stok, dan informasi relevan lain
                      dari Penjual sebelum melakukan pembelian.
                    </li>
                    <li>
                      Kami bertindak sebagai perantara yang memfasilitasi
                      Transaksi antara Anda dengan Penjual. Kami tidak
                      bertanggung jawab atas isi, deskripsi, atau kualitas
                      Produk, yang sepenuhnya merupakan tanggung jawab Penjual.
                    </li>
                    <li>
                      Anda berhak untuk mendapatkan Produk yang sesuai dan telah
                      dibayar penuh oleh Anda. Produk tidak dapat dikembalikan
                      atau dibatalkan secara sepihak oleh Anda.
                    </li>
                  </ol>
                ),
              },
            ],
          },
          {
            header: 'F. Struktur Biaya',
            content: [
              {
                content: (
                  <ol className="list-decimal pl-10 text-justify leading-8">
                    <li>
                      Dalam Transaksi penggunaan Layanan, selain Harga Layanan,
                      Anda akan dikenakan Biaya Layanan untuk setiap Layanan
                      yang Anda pilih melalui fitur-fitur yang tersedia dalam
                      Platform.
                    </li>
                    <li>
                      Dalam Transaksi pembelian Produk, selain Harga Produk dan
                      biaya pengiriman, Anda akan dikenakan Biaya Layanan untuk
                      setiap Transaksi <em>check out</em> yang dilakukan melalui
                      Platform sesuai dengan biaya yang tercantum pada Platform.
                      Biaya Layanan akan ditambahkan ke total pembayaran dan
                      harus dibayar penuh oleh Anda.
                    </li>
                    <li>
                      Harga Produk dan Harga Layanan yang tercantum adalah harga
                      final yang sudah termasuk pajak dan dalam mata uang
                      Rupiah.
                    </li>
                    <li>
                      Anda mengetahui dan menyetujui bahwa harga yang tercantum
                      pada Platform dapat mengalami perubahan sewaktu-waktu
                      tanpa adanya pemberitahuan terlebih dahulu.
                    </li>
                    <li>
                      Anda mengetahui dan menyetujui bahwa kewajiban perpajakan
                      yang timbul atas Transaksi akan ditanggung masing-masing
                      pihak sesuai dengan ketentuan perundang-undangan.
                    </li>
                  </ol>
                ),
              },
            ],
          },
        ],
      },
      {
        title: 'Bab III: Pengiriman, Pembatalan, dan Pengembalian Dana',
        header: [
          {
            header: 'G. Pengiriman Produk',
            content: [
              {
                content: (
                  <ol className="list-decimal pl-10 text-justify leading-8">
                    <li>
                      Kami bekerja sama dengan penyelenggara jasa pengiriman
                      untuk mengirimkan Produk kepada Anda.
                    </li>
                    <li>
                      Kami akan mengirimkan setiap Produk yang dipesan oleh Anda
                      sesuai dengan jasa pengiriman yang dipilih oleh Anda pada
                      Platform termasuk biaya pengiriman setelah mendapatkan
                      pembayaran penuh dari Anda sesuai dengan Harga Produk atau
                      nominal Transaksi Anda.
                    </li>
                    <li>
                      Anda wajib memastikan alamat pengiriman yang tertera pada
                      pesanan adalah alamat yang akurat dan lengkap untuk
                      menghindari kegagalan pengiriman.
                    </li>
                    <li>
                      Keterlambatan pengiriman yang disebabkan oleh kelalaian
                      Anda dalam memberikan alamat yang tidak akurat merupakan
                      tanggung jawab Anda sepenuhnya.
                    </li>
                    <li>
                      Seluruh risiko pada Produk akan berpindah kepada Anda pada
                      saat pengiriman Produk dilakukan.
                    </li>
                    <li>
                      Segala bentuk keluhan atas pengiriman merupakan tanggung
                      jawab dari penyelenggara jasa pengiriman. Kami akan
                      berupaya untuk memfasilitasi komunikasi antara Anda dengan
                      penyelenggara jasa pengiriman untuk menyelesaikan keluhan
                      atas pengiriman. Dengan demikian, Anda membebaskan Kami
                      dari segala kerugian yang timbul berkaitan dengan
                      pengiriman Produk.
                    </li>
                  </ol>
                ),
              },
            ],
          },
          {
            header: 'H. Pembatalan Transaksi Pembelian Produk',
            content: [
              {
                content: (
                  <ol className="list-decimal pl-10 text-justify leading-8">
                    <li>
                      Pembatalan Transaksi hanya dapat dilakukan jika Penjual
                      belum melakukan konfirmasi pesanan dan Anda telah
                      melakukan permintaan pembatalan melalui fitur yang
                      tersedia di Platform.
                    </li>
                    <li>
                      Dana dari pembatalan Transaksi Pembeli akan dikembalikan
                      sesuai dengan kebijakan pengembalian dana (<em>refund</em>
                      ) Platform.
                    </li>
                  </ol>
                ),
              },
            ],
          },
          {
            header:
              'I. Kebijakan Pengembalian Dana (Refund) untuk Pembelian Produk',
            content: [
              {
                content: (
                  <ol className="list-decimal pl-10 text-justify leading-8">
                    <li>
                      Apabila terjadi pengembalian dana (<em>refund</em>) akibat
                      masalah Produk atau pengiriman, Anda harus mengajukan
                      komplain melalui fitur yang tersedia di Platform dan
                      bernegosiasi langsung dengan Penjual untuk mencapai
                      kesepakatan.
                    </li>
                    <li>
                      Kami akan bertindak sebagai mediator untuk memfasilitasi
                      komunikasi antara Anda dan Penjual. Namun, Kami tidak
                      bertanggung jawab atas keputusan akhir pengembalian dana (
                      <em>refund</em>), yang sepenuhnya merupakan kesepakatan
                      antara Anda dan Penjual.
                    </li>
                    <li>
                      Jangka waktu pengembalian dana (<em>refund</em>) yang
                      telah disepakati oleh Anda dengan Penjual dengan jangka
                      waktu pengembalian dana (<em>refund</em>) maksimal 5
                      (lima) hari kerja yang dihitung setelah Anda memperoleh
                      persetujuan dari Penjual untuk dilakukan pengembalian dana
                      (<em>refund</em>) sesuai dengan metode pengembalian dana (
                      <em>refund</em>) yang disepakati.
                    </li>
                    <li>
                      Dalam hal terjadi pengembalian dana (<em>refund</em>),
                      Biaya Layanan yang telah dibayarkan oleh Anda tidak dapat
                      dikembalikan, Biaya Layanan merupakan biaya jasa yang
                      telah digunakan untuk memfasilitasi Transaksi awal. Anda
                      juga akan dikenakan potongan pengembalian dana (
                      <em>refund</em>).
                    </li>
                    <li>
                      Jumlah pengembalian dana (<em>refund</em>) yang disepakati
                      akan disesuaikan dengan nilai nominal Produk atas
                      Transaksi yang dilakukan oleh Anda dan yang telah diterima
                      oleh Penjual.
                    </li>
                  </ol>
                ),
              },
            ],
          },
        ],
      },
      {
        title: 'Bab IV: Pembatasan Tanggung Jawab dan Ganti Rugi',
        header: [
          {
            header: 'J. Pembatasan Tanggung Jawab',
            content: [
              {
                content: (
                  <ol className="list-decimal pl-10 text-justify leading-8">
                    <li>
                      Kami hanya berperan sebagai penyedia layanan Platform.
                    </li>
                    <li>
                      Anda setuju bahwa Anda memanfaatkan Layanan Platform atas
                      risiko Anda sendiri, dan Layanan Platform diberikan kepada
                      Anda dalam kondisi "apa adanya" dan "sebagaimana
                      tersedia".
                    </li>
                    <li>
                      Produk yang dijual melalui Platform merupakan tanggung
                      jawab dari Penjual yang melakukan penjualan Produk melalui
                      Platform.
                    </li>
                    <li>
                      Kami tidak bertanggung jawab dalam hal ketepatan atas
                      seluruh informasi yang ditayangkan melalui Platform. Anda
                      bertanggung jawab sepenuhnya atas kehilangan atau kerugian
                      langsung atau tidak langsung sehubungan dengan penggunaan
                      layanan Platform.
                    </li>
                    <li>
                      Kami berupaya untuk menjaga keamanan dan kinerja Platform,
                      namun tidak dapat menjamin bahwa operasi dan/atau akses ke
                      Platform akan selalu tanpa gangguan.
                    </li>
                    <li>
                      Sejauh diizinkan oleh hukum yang berlaku, Kami (termasuk
                      induk perusahaan, direktur, dan karyawan) tidak
                      bertanggung jawab, dan Anda setuju untuk tidak menuntut
                      Kami bertanggung jawab, atas segala kerusakan atau
                      kerugian (termasuk namun tidak terbatas pada hilangnya
                      uang, reputasi, keuntungan, atau kerugian tak berwujud
                      lainnya) yang diakibatkan secara langsung atau tidak
                      langsung dari:
                    </li>
                    <ol className="list-[lower-alpha] pl-10 text-justify leading-8">
                      <li>
                        Penggunaan atau ketidakmampuan Anda dalam menggunakan
                        layanan dalam Platform;
                      </li>
                      <li>
                        Harga, pengiriman atau petunjuk lain yang tersedia dalam
                        Platform;
                      </li>
                      <li>
                        Keterlambatan atau gangguan dalam layanan Platform;
                      </li>
                      <li>
                        Kelalaian dan kerugian yang ditimbulkan oleh
                        masing-masing Pengguna;
                      </li>
                      <li>
                        Kualitas Produk yang ditawarkan atau dijual melalui
                        Platform;
                      </li>
                      <li>Pengiriman Produk;</li>
                      <li>Pelanggaran atas hak kekayaan intelektual;</li>
                      <li>Perselisihan antar Pengguna;</li>
                      <li>Pencemaran nama baik pihak lain;</li>
                      <li>
                        Setiap penyalahgunaan Produk yang telah Anda beli
                        melalui Platform;
                      </li>
                      <li>
                        Kerugian akibat pembayaran tidak resmi kepada pihak lain
                        selain menggunakan metode pembayaran yang tercantum
                        dalam Platform, yang dengan cara apapun mengatasnamakan
                        Kami ataupun kelalaian penulisan rekening dan/atau
                        informasi lainnya dan/atau kelalaian pihak bank;
                      </li>
                      <li>
                        Pengiriman untuk perbaikan Produk yang bergaransi resmi
                        dari pihak produsen; Anda dapat membawa Produk yang Anda
                        beli melalui Platform langsung kepada pusat layanan
                        servis terdekat dengan kartu garansi dan faktur
                        pembelian;
                      </li>
                      <li>
                        Virus atau perangkat lunak berbahaya lainnya yang
                        diperoleh dengan mengakses, atau menghubungkan ke
                        Platform;
                      </li>
                      <li>
                        Gangguan, bug, kesalahan atau ketidakakuratan apapun
                        dalam layanan Platform;
                      </li>
                      <li>
                        Kerusakan pada perangkat keras Anda dari penggunaan
                        setiap layanan Platform;
                      </li>
                      <li>
                        Isi, tindakan, atau tidak adanya tindakan dari pihak
                        ketiga, termasuk terkait dengan Produk yang terdapat
                        dalam situs Platform yang diduga palsu;
                      </li>
                      <li>
                        Tindakan penegakan yang diambil sehubungan dengan akun
                        Anda;
                      </li>
                      <li>
                        Adanya tindakan peretasan yang dilakukan oleh pihak
                        ketiga kepada akun Anda.
                      </li>
                    </ol>
                  </ol>
                ),
              },
            ],
          },
          {
            header: 'K. Ganti Rugi',
            content: [
              {
                content: (
                  <div className="text-justify">
                    <p className="pl-5 text-justify leading-8">
                      Seluruh kerugian yang timbul dalam kaitannya dengan
                      tindakan pelanggaran Syarat dan Ketentuan, penggunaan
                      layanan Platform, pelanggaran terhadap pihak ketiga
                      dan/atau peraturan perundang-undangan yang berlaku di
                      Negara Republik Indonesia oleh Anda sepenuhnya menjadi
                      tanggung jawab Anda. Anda dengan ini menyetujui untuk
                      membebaskan Kami dari seluruh bentuk tanggung jawab, ganti
                      kerugian, gugatan atau tuntutan dari pihak yang dirugikan.
                    </p>
                  </div>
                ),
              },
            ],
          },
        ],
      },
      {
        title: 'Bab IV: Ketentuan Lain',
        header: [
          {
            header: 'L. Penggunaan Sistem Artificial Intelligence ("AI")',
            content: [
              {
                content: (
                  <ol className="list-decimal pl-10 text-justify leading-8">
                    <li>
                      Kami menggunakan AI dalam Platform untuk mendukung Kami
                      dalam menyediakan Layanan dan fitur kepada Anda, termasuk
                      namun tidak terbatas pada untuk memberikan informasi,
                      interaksi secara otomatis, analisis, dan rekomendasi.
                    </li>
                    <li>
                      Dengan menggunakan Platform, Anda setuju bahwa AI
                      merupakan salah satu fitur yang tersedia dalam Platform.
                    </li>
                    <li>
                      Anda setuju bahwa Kami tidak menjamin keakuratan dan
                      kelengkapan informasi yang disediakan oleh AI pada
                      Platform.
                    </li>
                    <li>
                      Kami dapat melakukan perubahan atau memperbarui AI dalam
                      peningkatan penyediaan Layanan sewaktu waktu tanpa
                      pemberitahuan terlebih dahulu kepada Anda.
                    </li>
                    <li>
                      Anda setuju bahwa Kami tidak bertanggung jawab terhadap
                      kerugian yang timbul dari penggunaan dan informasi yang
                      diberikan oleh AI pada Platform.
                    </li>
                  </ol>
                ),
              },
            ],
          },
          {
            header: 'M. Hak Kekayaan Intelektual',
            content: [
              {
                content: (
                  <div className="text-justify">
                    <p className="pl-5 text-justify leading-8">
                      Kami beserta lisensi Kami adalah pemegang hak atas seluruh
                      konten yang tersedia dalam Platform, termasuk namun tidak
                      terbatas pada ikon, grafis, judul, tombol ikon, logo, nama
                      layanan, dan teks yang dilindungi oleh peraturan
                      perundang-undangan terkait. Anda tidak diperbolehkan untuk
                      menggunakan, memanipulasi, mereproduksi atau
                      mendistribusikan seluruh konten yang tersedia dalam
                      Platform.
                    </p>
                  </div>
                ),
              },
            ],
          },
          {
            header: 'N. Pilihan Hukum dan Penyelesaian Perselisihan',
            content: [
              {
                content: (
                  <div className="text-justify">
                    <p className="pl-5 text-justify leading-8">
                      Syarat dan Ketentuan ini ditafsirkan, dilaksanakan, dan
                      tunduk berdasarkan hukum dan peraturan perundang-undangan
                      yang berlaku di Negara Republik Indonesia. Segala
                      perselisihan yang timbul sehubungan dengan penggunaan
                      layanan Platform antara Anda dengan Kami akan diselesaikan
                      terlebih dahulu dengan musyawarah. Apabila musyawarah
                      tidak dapat menyelesaikan perselisihan yang timbul, maka
                      perselisihan diselesaikan melalui Pengadilan Negeri
                      Jakarta Selatan.
                    </p>
                  </div>
                ),
              },
            ],
          },
          {
            header: 'O. Pembaharuan Syarat dan Ketentuan',
            content: [
              {
                content: (
                  <div className="text-justify">
                    <p className="pl-5 text-justify leading-8">
                      Kami berhak untuk mengubah atau memperbarui Syarat dan
                      Ketentuan ini sewaktu waktu tanpa adanya pemberitahuan
                      terlebih dahulu. Perubahan akan berlaku efektif setelah
                      diumumkan di Platform. Dengan terus menggunakan Platform,
                      maka Anda dianggap telah menyetujui setiap perubahan dalam
                      Syarat dan Ketentuan.
                    </p>
                  </div>
                ),
              },
            ],
          },
          {
            header: 'P. Penghentian Layanan',
            content: [
              {
                content: (
                  <ol className="list-decimal pl-10 text-justify leading-8">
                    <li>
                      Kami berhak, sewaktu-waktu, untuk segera menangguhkan,
                      membatasi, atau menghentikan akses Anda ke Platform jika
                      dinilai bahwa Anda telah melanggar ketentuan dalam Syarat
                      dan Ketentuan dan/atau Kebijakan Privasi dan/atau
                      peraturan perundang-undangan yang berlaku.
                    </li>
                    <li>
                      Kami dan Anda sepakat untuk mengesampingkan ketentuan
                      Pasal 1266 Kitab Undang-Undang Hukum Perdata sehingga
                      penghentian akses sebagaimana dimaksud dapat dilakukan
                      tanpa memerlukan putusan pengadilan terlebih dahulu.
                    </li>
                  </ol>
                ),
              },
            ],
          },
          {
            header: 'Q. Hubungi Kami',
            content: [
              {
                content: (
                  <div className="text-justify">
                    <p className="pl-5 text-justify leading-8">
                      Jika Anda memiliki pertanyaan, komentar atau keluhan
                      terhadap Syarat dan Ketentuan ini, Anda dapat menghubungi
                      tim <em>customer service</em> Kami melalui{' '}
                      <em>WhatsApp</em> resmi Kami yang informasinya tercantum
                      pada Platform.
                    </p>
                  </div>
                ),
              },
            ],
          },
        ],
      },
    ],
  },
];
